import { fontSize as fontSize_1 } from './fontSize.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { FontSizePicker } from 'owa-editor-ribbon-secondary-ui';
import type { RibbonButton, RibbonDropDownProps } from './RibbonButton';
import { callFormatApi } from 'owa-editor/lib/utils/callApi';
import createLivePreviewHandler from 'owa-editor-live-preview/lib/utils/createLivePreviewHandler';
import { isFeatureEnabled } from 'owa-feature-flags';

const fontSize: RibbonButton = {
    key: 'fontSize',
    title: () => loc(fontSize_1),
    imageSrc: require('../svg/fontsize.svg'),
    createDropDownCallback: React.memo(
        ({ editorViewState, formatState, target, dismiss }: RibbonDropDownProps) => {
            const onSelectSize = React.useCallback(
                (fontSize: string) =>
                    callFormatApi(editorViewState, 'setFontSize', [fontSize + 'pt']),
                [editorViewState]
            );
            const livePreview =
                isFeatureEnabled('cmp-live-preview') &&
                createLivePreviewHandler(editorViewState, onSelectSize);
            return (
                <FontSizePicker
                    menuTargetElement={target}
                    onDismissMenu={dismiss}
                    onSelect={onSelectSize}
                    selectedValue={formatState.fontSize}
                    livePreview={livePreview}
                />
            );
        }
    ),
};

export default fontSize;
